/** Resolve the API order identity, never a display channel or placement key. */
export const getDetailOrderId = (
  order: { id?: unknown; _id?: unknown; orderId?: unknown } | null | undefined
) => String(order?.id || order?._id || order?.orderId || '');
